import React, { Suspense, useState } from "react";
import {
  Alert,
  Button,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import LeftBG from "../assets/images/Vector52.png";
import LogoDesa from "../assets/images/register/desapedia.png";
import { config } from "../config";
import LoadingOverlay from "../component/Loading";
import axios from "axios";

const RegisterPartner = () => {
  const [modal, setModal] = useState(false);

  const [form, setForm] = useState({
    nama: "",
    nomorHp: "",
    email: "",
    alamat: "",
  });

  const [errors, setErrors] = useState({
    message: "",
  });

  const [visibleError, setVisibleError] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const onDismiss = () => setVisibleError(false);
  const toggle = () => setModal(!modal);
  const toggleError = () => setModalError(!modalError);
  const toggleSuccess = () => setModalSuccess(!modalSuccess);

  const PreLoader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      </div>
    );
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleKeyPress = (event) => {
    const keyCode = event.which || event.keyCode;
    const keyValue = String.fromCharCode(keyCode);
    if (!/^[0-9]+$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  // --- FUNGSI VALIDASI EMAIL ---
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const onSubmit = async () => {
    setModal(false);
    setLoading(true);

    try {
      const dataToSend = [
        {
          ...form,
          muserId: "User Landing Page",
          createdBy: "User Landing Page",
          updatedBy: "User Landing Page",
        },
      ];

      const response = await axios.post(
        `${config.BASE_URL}registerPartner/create`,
        dataToSend,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      setLoading(false);
      if (response && (response.status === 200 || response.status === 201)) {
        toggleSuccess();
      } else {
        setErrorMessage("Gagal mengirim data. Silahkan coba lagi.");
        setModalError(true);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error Detail:", error);

      // Cek apakah error karena CSP / Network Blocked
      if (!error.response) {
        setErrorMessage(
          "Koneksi diblokir atau masalah jaringan. Pastikan API diizinkan di kebijakan CSP."
        );
      } else if (error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage("Terjadi kesalahan sistem. Silahkan coba lagi.");
      }

      setModalError(true);
    }
  };

  const handleConfirm = (event) => {
    event.preventDefault();

    // 1. Validasi Nomor HP
    if (!/^\d+$/.test(form.nomorHp)) {
      setVisibleError(true);
      setErrors({ message: "Nomor HP tidak valid" });
      return;
    }

    // 2. Validasi Email (TAMBAHAN BARU)
    if (!validateEmail(form.email)) {
      setVisibleError(true);
      setErrors({
        message: "Format Email tidak valid (contoh: user@mail.com)",
      });
      return;
    }

    // Jika semua valid
    setVisibleError(false);
    toggle();
    setErrors({ message: "" });
  };

  return (
    <React.Fragment>
      {loading && <LoadingOverlay />}

      {/* Modal Success */}
      <Modal isOpen={modalSuccess} toggle={toggleSuccess} centered>
        <ModalBody>
          <Alert>
            <h4 className="alert-heading">Register Sukses!</h4>
            <p>
              Selamat Anda sudah sukses mengirimkan data untuk melakukan proses
              pendaftaran, Admin akan melakukan verifikasi data
            </p>
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={() => setModalSuccess(false)}
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Error */}
      <Modal isOpen={modalError} toggle={toggleError} centered>
        <ModalBody>
          {errorMessage
            ? errorMessage
            : "Maaf register saat ini tidak dapat dilakukan. Silahkan coba beberapa saat lagi"}
        </ModalBody>
        <ModalFooter style={{ border: "none" }}>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={() => setModalError(false)}
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Konfirmasi */}
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalBody>Apakah Anda yakin ingin mengirim data berikut?</ModalBody>
        <ModalFooter style={{ border: "none" }}>
          <Button
            style={{ background: "#FF5C30" }}
            size="sm"
            onClick={onSubmit}
          >
            Iya
          </Button>
          <Button style={{ background: "gray" }} size="sm" onClick={toggle}>
            Batal
          </Button>
        </ModalFooter>
      </Modal>

      <Suspense fallback={PreLoader}>
        <Container id="register-partner">
          <button
            style={{
              position: "absolute",
              zIndex: "100",
              left: 32,
              top: 24,
              background: "transparent",
              border: 0,
            }}
            onClick={() => (window.location.href = "/")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="white"
              className="bi bi-arrow-left"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
              />
            </svg>
          </button>

          <img src={LeftBG} alt="" />
          <div className="separator">
            <img src={LogoDesa} alt="desapedia" />
            <div className="form">
              <h1>Register Partner</h1>
              {errors.message && (
                <Alert color="danger" isOpen={visibleError} toggle={onDismiss}>
                  {errors.message}
                </Alert>
              )}

              <form action="" onSubmit={handleConfirm}>
                <label htmlFor="nama">Nama Instansi</label>
                <input
                  name="nama"
                  type="text"
                  id="nama"
                  value={form.nama}
                  onChange={handleInputChange}
                  placeholder="Isi Nama Instansi Lengkap Anda"
                />

                <label htmlFor="nomorHp">No Telp</label>
                <input
                  maxLength={14}
                  name="nomorHp"
                  type="text"
                  id="nomorHp"
                  value={form.nomorHp}
                  onKeyPress={handleKeyPress}
                  onChange={handleInputChange}
                  placeholder="Isi Nomor Telfon / HP Anda"
                />

                <label htmlFor="email">Email</label>
                <input
                  name="email"
                  type="text"
                  id="email"
                  value={form.email}
                  onChange={handleInputChange}
                  placeholder="Isi Email Anda"
                />

                <label htmlFor="alamat">Alamat Lengkap</label>
                <textarea
                  type="text"
                  name="alamat"
                  id="alamat"
                  rows="3"
                  className="form-control"
                  style={{
                    width: "100%",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    padding: "10px",
                    borderColor: "#ced4da",
                  }}
                  value={form.alamat}
                  onChange={handleInputChange}
                  placeholder="Isi Alamat Lengkap Instansi"
                />

                <input
                  type="submit"
                  value="Register"
                  disabled={
                    !form.nama || !form.nomorHp || !form.email || !form.alamat
                  }
                />
              </form>
            </div>
          </div>
        </Container>
      </Suspense>
    </React.Fragment>
  );
};

export default RegisterPartner;
